import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldOff, ArrowLeft } from 'lucide-react';
import { Container } from '../../components/layout/Container';
import { Button } from '../../components/ui/Button';

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero section with gradient background */}
      <div className="relative h-40 bg-gradient-to-r from-red-600 to-red-500">
        {/* Solid color header for navbar visibility */}
        <div className="absolute top-0 left-0 right-0 h-20 bg-gradient-to-b from-red-800/80 to-transparent z-10"></div>
      </div>

      <Container
        size="md"
        className="-mt-20 flex items-center justify-center py-12"
      >
        <div className="bg-white p-12 rounded-3xl shadow-xl text-center w-full max-w-lg">
          <div className="inline-flex items-center justify-center p-6 bg-red-100 rounded-full mb-8">
            <ShieldOff className="w-16 h-16 text-red-600" />
          </div>

          <h1 className="text-4xl font-bold mb-4">Access Denied</h1>

          <p className="text-xl text-gray-600 mb-8 max-w-lg mx-auto">
            You don't have permission to access this page. Please contact your
            administrator if you believe this is an error.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              className="flex items-center gap-2"
            >
              <ArrowLeft className="w-5 h-5" />
              Go Back
            </Button>

            <Button onClick={() => navigate('/dashboard')}>
              Go to Dashboard
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default UnauthorizedPage;
